module.exports = __webpack_public_path__ + "h5/img/dpj.552b5a17.png";